<template>
  <form class="form form-user-basic" @submit.prevent="postBasic">
    <slide-x-left-transition :duration="400" :delay="200">
      <div class="form-group" v-show="show">
        <label>Imię</label>
        <div class="input-wrapper">
          <input v-model="form.first_name"
                 type="text"
                 :class="{'input-error' : errors.first_name }"
                 placeholder="Podaj imię"
                 ref="firstNameInput"
                 required/>
        </div>
        <p class="error" v-if="errors.first_name">{{ errors.first_name[0] }}</p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="500" :delay="300">
      <div class="form-group" v-show="show">
        <label>Nazwisko</label>
        <div class="input-wrapper">
          <input v-model="form.last_name"
                 type="text"
                 :class="{'input-error' : errors.last_name }"
                 placeholder="Podaj nazwisko"
                 ref="lastNameInput"
                 required/>
        </div>
        <p class="error" v-if="errors.last_name">{{ errors.last_name[0] }}</p>
      </div>
    </slide-x-left-transition>
    <ion-button mode="ios" expand="block" type="submit" :disabled="loading">
      <span v-if="loading"><span class="loader"></span></span>
      <span v-else>Zapisz</span>
    </ion-button>
  </form>
</template>

<script>
  import api from '@/services/Api';
  import goTo from '@/mixins/goto';
  import {mapState} from "vuex";

  export default {
    name: 'FormUserBasic',
    mixins: [goTo],
    computed: {
      form: {
        get() {
          return this.$store.state.profile.details
        }
      },
      ...mapState({
        errors: state => state.profile.errors,
        loading: state => state.profile.loading,
      })
    },
    data() {
      return {
        show: false
      }
    },
    mounted(){
      this.show = true
    },
    methods: {
      postBasic() {
        this.$store.dispatch('profile/UPDATE_PROFILE_NAME_REQUEST', this.form).then(resp => {
          this.goBack()
        })
      }
    }
  }
</script>